import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { IntegrationState } from "../types";
import API from "@/axios";

const actions: ActionTree<IntegrationState, RootState> = {
  fetchCredentials({ commit }) {
    return API.get("/settings/credentials").then(async (response) => {
      const {
        data: { publicKey, secret },
      } = response;
      if (publicKey && secret) {
        commit("setPublicKey", publicKey);
        commit("setSecretKey", secret);
      }
    });
  },
};

export default actions;
